/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageBotLotsDto } from '../../models/usage-bot-lots-dto';

export interface GetUsageBotLots$Params {
  from?: string;
  to?: string;
  bot?: string;
  take?: number;
  'X-API-Version'?: string;
}

export function getUsageBotLots(http: HttpClient, rootUrl: string, params?: GetUsageBotLots$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageBotLotsDto>> {
  const rb = new RequestBuilder(rootUrl, getUsageBotLots.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('bot', params.bot, {});
    rb.query('take', params.take, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageBotLotsDto>;
    })
  );
}

getUsageBotLots.PATH = '/api/usage-statistics/bots/lots';
